
<div class="set-address">
  <div class="modal set-address-modal">
    <div class="modal-background" @click="closeModal" />
    <button class="modal-close is-large" @click="closeModal" />

    <div class="modal-card">
      <section class="modal-card-body">
        <p class="err-msg" v-if="error">{{ errorMsg }}</p>
        <div class="field is-grouped" style="margin-bottom: 3px">
          <p class="control is-expanded has-icons-left has-icons-right">
            <input
              style="display: none"
              type="address"
              name="fakeusernameremembered"
            />
            <input
              class="input is-medium"
              type="text"
              v-model="locationInput"
              ref="autocomplete"
              :placeholder="placeholderText"
              onfocus="value = ''"
              onpaste="return false;"
              ondrop="return false;"
              v-on:keyup="checkLength"
              autocomplete="hide-address-autofill"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-globe-asia" />
            </span>
            <span
              v-if="locationInput"
              class="icon is-small is-right"
              style="pointer-events: initial"
              @click="locationInput = null"
            >
              <i class="fa fa-times-circle" />
            </span>
          </p>
          <p v-if="!locationInput" class="control">
            <span
              class="button is-white is-medium"
              style="padding: 4px"
              @click="triggerPaste"
            >
              <a class="has-text-info"><i class="far fa-edit" /></a>
            </span>
          </p>
        </div>

        <!-- <span class="button is-pulled-right places-btn" @click="triggerPaste">
          <a class="has-text-link"><i class="far fa-edit" />&nbsp;lat,lon</a>
        </span> -->

        <div class="map-wrapper">
          <div :id="mapID" class="map">
            <div v-if="userCoords" class="leaflet-top leaflet-right">
              <div class="center-btn button is-rounded" @click="recenter">
                <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
              </div>
            </div>
          </div>
        </div>

        <div class="confirm-btn">
          <a
            class="button is-info is-medium is-fullwidth"
            @click="confirmLocation"
          >
            {{ $t("confirm-address") }}
          </a>
        </div>
      </section>
    </div>
  </div>
</div>
